/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M10.9196.2931a2.1376 2.1376 0 0 1 2.1608 0l8.4 4.9368C22.113 5.6016 22.5 6.2712 22.5 6.9937v10.0126c0 .7225-.387 1.3921-1.0196 1.7638l-8.4 4.9368a2.1378 2.1378 0 0 1-2.1608 0l-8.4-4.9368C1.887 18.3984 1.5 17.7288 1.5 17.0063V6.9937c0-.7225.387-1.392 1.0196-1.7638l8.4-4.9368ZM3 8.1561v8.8502c0 .1807.0968.3632.2796.4706l7.9704 4.6843v-9.2288L3 8.1561Zm9.75 14.0051 7.9704-4.6843c.1828-.1074.2796-.2899.2796-.4706V8.1561l-8.25 4.7763v9.2288Z"
    clipRule="evenodd"
  />,
  'MenuSubProjectFilled'
);
